import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import css from './App.css';
import { hot } from 'react-hot-loader';
import { getScheduleConnectionURL, getConnectionURL } from '../utils/deepLinks';
import StyledButton from '../common/StyledButton';
import copy from 'clipboard-copy';
import Toast from 'common/Toast';

const App = ({getValue, setValue}) => {
  const [appointmentLinkAvailable, setAppointmentLinkAvailable] = useState(getValue("appointmentLinkAvailable") === 'true'); // hacky way to find if the value is true or valse, extjs return the value as string like 'false'
  const [profileLinkAvailable, setProfileLinkAvailable] = useState(getValue("profileLinkAvailable") === 'true');
  const [showToast, setShowToast] = useState(false);
  const instructorId = getValue("instructorId");

  const copyAppointmentLink = async () => {
    try {
      await copy(getScheduleConnectionURL(instructorId));
      setShowToast(true);
    } catch (e) {
      console.warn(e);
    }
  }

  const copyProfileLink = async () => {
    try {
      await copy(getConnectionURL(instructorId));
      setShowToast(true);
    } catch (e) {
      console.warn(e);
    }
  }

  useEffect(() => {
    setValue("appointmentLinkAvailable", appointmentLinkAvailable);
  }, [appointmentLinkAvailable]);

  useEffect(() => {
    setValue("profileLinkAvailable", profileLinkAvailable);
  }, [profileLinkAvailable]);

  return (
    <div className={css['container']}>
      <h3 className="sf-admin-title">Share Links</h3>
      <p>
        Share your appointment and/or profile link with students by copying the link(s) to 
        the clipboard. You can use the links in emails, email signatures, a non-Starfish 
        web page, etc. If you’d like for your links to display for staff to share, select 
        the appropriate checkbox(es) below to display the link(s) on your Connection Profile 
        in the Services tab. Students who receive a link to schedule an appointment with you 
        or view your profile will only be able to use the link if they have a relationship in 
        Starfish with you. Note: If you are having trouble copying a link, try using another 
        web browser.
      </p>
      <div className={css['link-container']}>
        <b>Link to schedule an appointment with me</b>
        <div>
          {getScheduleConnectionURL(instructorId)}
          <StyledButton data-testid="copy-appt" asLink onClick={copyAppointmentLink}>
            Copy link to clipboard
          </StyledButton>
        </div>
        <div className={css['checkbox-container']}>
          <input
            id="schedule-appt-link-checkbox" 
            data-testid="schedule-appt-link-checkbox"
            type="checkbox"
            checked={appointmentLinkAvailable}
            onChange={e => setAppointmentLinkAvailable(e.target.checked)}
          />
          <label htmlFor="schedule-appt-link-checkbox">
            Make link available in the Services tab on my profile for other staff to copy.
          </label>
        </div>
      </div>
      <div className={css['link-container']}>
        <b>Link to view my profile</b>
        <div>
          {getConnectionURL(instructorId)}
          <StyledButton data-testid="copy-profile" asLink onClick={copyProfileLink}>
            Copy link to clipboard
          </StyledButton>
        </div>
        <div className={css['checkbox-container']}>
          <input
            id="profile-link-checkbox" 
            data-testid="profile-link-checkbox"
            type="checkbox"
            checked={profileLinkAvailable}
            onChange={e => setProfileLinkAvailable(e.target.checked)}
          />
          <label htmlFor="profile-link-checkbox">
            Make link available in the Services tab on my profile for other staff to copy.
          </label>
        </div>
      </div>
      {showToast && <Toast message={"Link copied to your clipboard."} onTimeout={() => setShowToast(false)} />}
    </div>
  );
};

App.propTypes = {
  getValue: PropTypes.func.isRequired,
  setValue: PropTypes.func.isRequired,
};

export default hot(module)(App);
